module.exports = new __parcel__URL__("12-angry-men.b8cd9b8d.jpg").toString();